<template>
  <div id="app">
    <v-app>
      <v-app-bar color="#343a40" dark app v-if="showAppBar">
        
        <img :src="require( './assets/logo.png' )" width="25" style="margin-right:15px;">
        
        <div class="ml-3 pl-3">
          <v-btn text class="mx-1" to="/">Invoices</v-btn>
          <v-btn text class="mx-1" to="/customers">Customers</v-btn>
          <v-btn text class="mx-1" to="/rotationdays">Rotation Days</v-btn>
          <v-btn text class="mx-1" to="/billingcalendar">Billing Calendar</v-btn>
          <v-btn text class="mx-1" to="/rotationdayscalendar">Rotation Days Calendar</v-btn>
        </div>

        <v-spacer></v-spacer>

        <v-btn text color="red" @click="doLogout">Logout</v-btn>
      </v-app-bar>
      <v-content>
        <router-view />
      </v-content>
    </v-app>
  </div>
</template>

<script>
export default {
  computed: {
    showAppBar() {
      if( this.$route.path == '/login' )
        return false;

      return true;
    }
  },
  watch: {
    $route( to ) {
      // console.log(this.$router.options.routes);
      let found = this.$router.options.routes.find(route => {
        return route.path == to.path;
      });

      if( found == undefined || found == null || !this.isLoggedIn() ) {
        this.$router.push('/login');
      }
    }
  },
  methods: {
    doLogout() {
      this.logout();
      this.$router.push('/login');
    }
  }
}
</script>

<style lang="scss">

</style>
